import * as tslib_1 from "tslib";
import { Button, Checkbox, Icon, Modal, Pagination, Tooltip } from "@h3/antd-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { listApi, listParams } from "../../../../../../api";
import { DataItemType } from "../../../../../schema";
import SelectUser from "./select-user.vue";
import sheet from "./sheet.vue";
const WorkflowCenterModule = namespace("WorkflowCenter/WorkflowCenter");
let ImportErrModal = class ImportErrModal extends Vue {
    constructor() {
        super(...arguments);
        this.showModal = false;
        this.total = 0;
        this.pageSize = 20;
        this.curPage = 1;
        this.columns = [];
        this.dataSource = [];
        // 分页配置项
        this.pageSizeOptions = ["10", "20", "50", "100"];
        this.showBacthUpdate = false;
        this.batchList = [
            {
                type: undefined,
                value: undefined,
                data: undefined,
                dataItem: [],
                typeList: [],
            },
        ];
        this.dataItem = [];
        this.dataItemAll = [];
        this.itemContentList = [];
        this.errType = {
            Repeat: 1,
            NoExisted: 2,
            Null: 3,
            DisableDept: 4,
        };
        this.filterList = [];
    }
    get isHalfSuccess() {
        return this.status === listParams.ImportResult.PartialSuccess;
    }
    /*
     * 初始化表头
     */
    initColumns() {
        const dataItem = [];
        const _columns = this.importData.headColumns
            .map((col, idx) => {
            let colWidth = this.caculateColWidth(col);
            let childColumns = null;
            if (col.propertyType === DataItemType.StaffSingle ||
                col.propertyType === DataItemType.StaffMulti ||
                col.propertyType === DataItemType.DeptSingle ||
                col.propertyType === DataItemType.DeptMulti ||
                col.propertyType === DataItemType.StaffDeptMix) {
                dataItem.push({
                    title: col.name,
                    dataIndex: col.code,
                    propertyType: col.propertyType,
                    displayFormat: col.displayFormat,
                    width: colWidth,
                    key: col.code,
                    childColumns,
                });
            }
            // 子表初始化其子数据项
            if (col.propertyType === DataItemType.Sheet) {
                if (!col.childColumns || !col.childColumns.length) {
                    return;
                }
                let childSheetWidth = 0;
                childColumns = col.childColumns.map((child) => {
                    const childWidth = this.caculateColWidth(child);
                    childSheetWidth += childWidth;
                    return {
                        title: child.name,
                        dataIndex: child.propertyCode,
                        propertyType: child.propertyType,
                        width: childWidth,
                        key: child.propertyCode,
                    };
                });
                colWidth = childSheetWidth + 46;
                //子表添加
                if (Array.isArray(childColumns) && childColumns.length > 0) {
                    const indexColumn = {
                        dataIndex: "index",
                        propertyType: 0,
                        width: 46,
                        key: "index",
                    };
                    childColumns.unshift(indexColumn);
                }
            }
            const back = {
                title: col.name,
                dataIndex: col.code,
                propertyType: col.propertyType,
                displayFormat: col.displayFormat,
                width: colWidth,
                key: col.code,
                childColumns,
            };
            return back;
        })
            .filter(Boolean);
        this.dataItemAll = JSON.parse(JSON.stringify(_columns));
        this.dataItem = JSON.parse(JSON.stringify(dataItem));
        this.batchList[0].dataItem = JSON.parse(JSON.stringify(dataItem));
        // 增加序号列
        if (_columns.length) {
            const indexColumn = {
                dataIndex: "index",
                propertyType: 0,
                width: 46,
                key: "index",
                childColumns: null,
            };
            _columns.unshift(indexColumn);
        }
        console.log(_columns, "_columns_columns", this.dataItem);
        this.columns = _columns;
    }
    /*
     * 初始化表格数据（本地分页）
     */
    initTableData() {
        if (this.importData && this.importData.secondImportData) {
            this.itemContentList = JSON.parse(JSON.stringify(this.importData.secondImportData));
            this.dataSource = this.importData.secondImportData.slice(0, this.pageSize);
            this.total = this.importData.secondImportData.length;
        }
    }
    /*
     * 分页改变
     */
    onPaginationChange(page, size) {
        this.curPage = page;
        this.dataSource = this.importData.secondImportData.slice((page - 1) * this.pageSize, page * this.pageSize);
    }
    /*
     * 分页pageSize改变
     */
    onSizeChange(current, size) {
        this.curPage = 1;
        this.pageSize = size;
        this.dataSource = this.importData.secondImportData.slice(0, size);
    }
    /*
     * 计算记录中列的宽度
     */
    caculateColWidth(col) {
        const longInput = [1, 5, 8, 9, 10];
        if (longInput.includes(col.propertyType)) {
            return 252;
        }
        return 162;
    }
    /*
     * 确定导入
     */
    sureImport() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // ;
            this.importData.secondImportData.forEach((data) => {
                delete data.index;
                delete data.key;
            });
            const params = {
                headColumns: this.importData.headColumns,
                secondImportData: this.importData.secondImportData,
            };
            const res = yield listApi.sheetSecondImportData(params);
            if (res.errcode === 0) {
                this.$message.success(this.$t("cloudpivot.list.pc.ImportSuccess"));
                this.editFinishe();
            }
            else {
                if (res.errcode === 303030 && res.data) {
                    this.$message.error(this.$t("cloudpivot.list.pc.ImportTestError"));
                    // this.$message.error(res.errmsg);
                    this.importData.secondImportData = res.data.secondImportData;
                    // this.importData = {
                    //   headColumns: res.data.headColumns,
                    //   secondImportData: res.data.secondImportData,
                    //   queryField: res.data.queryField
                    // }
                    this.initColumns();
                    this.initTableData();
                    return;
                }
                this.$message.error(res.errmsg);
            }
        });
    }
    editFinishe() {
        this.$emit("editFinishe", this.importData.secondImportData);
    }
    cancel() {
        this.clearBatchData();
        this.$emit("cancel");
        //成功或失败都无需做处理
        // listApi.deleteTemporaryFile({fileName: this.fileName});
        // this.$emit('editFinishe', this.importData.secondImportData)
        // this.$emit('reloadList', 'reload');
        // this.$emit('input', false);
    }
    /**
     * 下载错误信息文档
     */
    exportErrorResult() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield listApi.exportErrorResult(this.fileName);
            if ((res.errcode && res.errcode !== 0) || res.byteLength < 100) {
                this.$message.error(this.$t("cloudpivot.list.pc.DownloadFailed"));
            }
            else {
                const blob = new Blob([res], { type: "application/vnd.ms-excel" });
                const stamp = new Date().getMilliseconds();
                const fileName = `${this.applicationPageTitle}错误信息${this.getTime()}.xlsx`;
                this.downloadFile(blob, fileName);
            }
        });
    }
    getTime() {
        const date = new Date();
        const mounth = date.getMonth() > 8 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
        const days = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
        const hours = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
        const minutes = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
        const seconds = date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`;
        const stamp = `${date.getFullYear()}${mounth}${days}${hours}${minutes}${seconds}`;
        return stamp;
    }
    downloadFile(blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
        }
        else {
            const a = document.createElement("a");
            const url = URL.createObjectURL(blob);
            a.download = fileName;
            a.href = url;
            a.click();
            URL.revokeObjectURL(url);
        }
    }
    /*
     * 重置分页器参数
     */
    resetPagination() {
        this.total = 0;
        this.curPage = 1;
        this.pageSize = 20;
    }
    onValueChange(v) {
        this.showModal = v;
        if (v) {
            this.initColumns();
            this.initTableData();
        }
        else {
            this.resetPagination();
        }
    }
    handleOnBatchUpdate() {
        this.showBacthUpdate = !this.showBacthUpdate;
    }
    // 删除行
    delRows(index, key) {
        this[key].splice(index, 1);
    }
    // 添加行
    addRows(type) {
        // newRow Data
        const newRow = {
            type: undefined,
            value: undefined,
            data: undefined,
            dataItem: this.dataItem,
            typeList: [],
        };
        this.batchList.push(...[newRow]);
    }
    addRowsFilter(type) {
        // newRow Data
        const newRow = {
            type: undefined,
            data: undefined,
            dataItem: this.dataItemAll,
            typeList: [],
        };
        this.filterList.push(...[newRow]);
    }
    handleChangeDataItem(row, index) {
        let arr = [];
        let arr2 = [];
        if (row.data === "allData") {
            row.dataItem.forEach((o) => {
                this.importData.secondImportData.forEach((i) => {
                    if (i[o.dataIndex]) {
                        if (Array.isArray(i[o.dataIndex])) {
                            const obj = this.changeData(i[o.dataIndex], arr, arr2);
                            if (obj.arr && obj.arr.length > 0)
                                arr = obj.arr;
                            if (obj.arr2 && obj.arr2.length > 0)
                                arr2 = obj.arr2;
                        }
                        else if (typeof i[o.dataIndex] === "string") {
                            const l = arr.filter((i) => i === i[o.dataIndex]);
                            if (!l || (l && l.length <= 0))
                                arr.push(i[o.dataIndex]);
                        }
                    }
                });
            });
        }
        else {
            this.importData.secondImportData.forEach((e) => {
                if (e[row.data]) {
                    if (Array.isArray(e[row.data])) {
                        const obj = this.changeData(e[row.data], arr, arr2);
                        if (obj.arr && obj.arr.length > 0)
                            arr = obj.arr;
                        if (obj.arr2 && obj.arr2.length > 0)
                            arr2 = obj.arr2;
                    }
                    else {
                        const l = arr.filter((i) => i === e[row.data]);
                        if (!l || (l && l.length <= 0))
                            arr.push(e[row.data]);
                    }
                }
            });
        }
        row.type = undefined;
        row.typeList = [...arr, ...arr2];
        console.log(row, "dddd");
    }
    changeData(list, arr, arr2) {
        if (list) {
            let status = list.filter((i) => i.excelType);
            const name = list.map((i) => i.name);
            if (status && status.length > 0) {
                if (arr.length > 0) {
                    let a = arr.filter((i) => JSON.stringify(list) === JSON.stringify(i));
                    if (!a || (a && a.length <= 0)) {
                        if (list && list.length > 0)
                            arr = arr.concat([list]);
                    }
                }
                else {
                    if (list && list.length > 0)
                        arr = arr.concat([list]);
                }
            }
            else {
                if (arr2.length > 0) {
                    let a = arr2.filter((i) => JSON.stringify(list) === JSON.stringify(i));
                    if (!a || (a && a.length <= 0)) {
                        if (list && list.length > 0)
                            arr2 = arr2.concat([list]);
                    }
                }
                else {
                    if (list && list.length > 0)
                        arr2 = arr2.concat([list]);
                }
            }
        }
        return { arr, arr2 };
    }
    handleChangeContent(row, index) {
        console.log(row, "ddd");
        // const i = row.typeList.filter((i) => {
        //   if (row.type === i.map((o) => o.name).join("、")) {
        //     return i;
        //   }
        // });
        // row.value = i[0] ? i[0] : undefined;
    }
    getNameAndErrorText(name, type) {
        let errCode = "";
        switch (type) {
            case this.errType.Repeat:
                errCode = `${this.$t("cloudpivot.list.pc.repeat")}`;
                break;
            case this.errType.NoExisted:
                errCode = `${this.$t("cloudpivot.list.pc.noExisted")}`;
                break;
            case this.errType.Null:
                errCode = `${this.$t("cloudpivot.list.pc.null")}`;
                break;
            case this.errType.DisableDept:
                errCode = `${this.$t("cloudpivot.list.pc.deptDisable")}`;
                break;
        }
        return `${name ? name : ""}${errCode}`;
    }
    filterOption(input, option) {
        return (option.componentOptions.propsData.value
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0);
    }
    handleOnBatchConfirm() {
        let arr = [];
        if (this.filterList.length > 0) {
            this.filterList.forEach((i) => {
                this.importData.secondImportData.map((v) => {
                    if (v[i.data]) {
                        if (Array.isArray(v[i.data])) {
                            const name = v[i.data]
                                .map((e) => (e.id ? e.id : e.name))
                                .join("、");
                            if (name === i.type) {
                                arr.push(v);
                            }
                        }
                        else if (typeof v[i.data] === "string") {
                            if (v[i.data] === i.type) {
                                arr.push(v);
                            }
                        }
                    }
                });
            });
            if (arr.length > 0) {
                this.importData.secondImportData = arr;
            }
        }
        this.batchList.forEach((i) => {
            if (i.data === "allData") {
                i.dataItem.forEach((o) => {
                    this.importData.secondImportData.forEach((v) => {
                        if (v[o.dataIndex]) {
                            const name = v[o.dataIndex]
                                .map((e) => (e.id ? e.id : e.name))
                                .join("、");
                            if (name === i.type) {
                                v[o.dataIndex] = i.value;
                            }
                        }
                    });
                });
            }
            else {
                this.importData.secondImportData.forEach((v) => {
                    if (v[i.data]) {
                        const name = v[i.data]
                            .map((e) => (e.id ? e.id : e.name))
                            .join("、");
                        if (name === i.type) {
                            v[i.data] = i.value;
                        }
                    }
                });
            }
        });
        this.clearBatchData();
        console.log(this.importData.secondImportData, "this.dataSourcethis.dataSource", this.filterList, "ddd", arr);
    }
    clearBatchData() {
        this.showBacthUpdate = false;
        this.batchList = [
            {
                type: undefined,
                value: undefined,
                data: undefined,
                dataItem: [],
                typeList: [],
            },
        ];
        this.filterList = [];
        this.initColumns();
        this.initTableData();
    }
};
tslib_1.__decorate([
    WorkflowCenterModule.State("applicationPageTitle")
], ImportErrModal.prototype, "applicationPageTitle", void 0);
tslib_1.__decorate([
    Prop()
], ImportErrModal.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 0,
    })
], ImportErrModal.prototype, "successNum", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 0,
    })
], ImportErrModal.prototype, "failNum", void 0);
tslib_1.__decorate([
    Prop({
        type: Number,
        default: 8,
    })
], ImportErrModal.prototype, "status", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
    })
], ImportErrModal.prototype, "fileName", void 0);
tslib_1.__decorate([
    Prop()
], ImportErrModal.prototype, "importData", void 0);
tslib_1.__decorate([
    Watch("value")
], ImportErrModal.prototype, "onValueChange", null);
ImportErrModal = tslib_1.__decorate([
    Component({
        name: "import-err-modal",
        components: {
            sheet,
            AModal: Modal,
            AIcon: Icon,
            AButton: Button,
            ACheckbox: Checkbox,
            ATooltip: Tooltip,
            SelectUser,
            APagination: Pagination,
        },
    })
], ImportErrModal);
export default ImportErrModal;
